import { Amazon, Blockquote, InternalLink, Twitter } from '../../../../src/components/blog';
import * as React from 'react';
export default {
  Amazon,
  Blockquote,
  InternalLink,
  Twitter,
  React
};